import React from "react"
import SiteHeading from "../../../../utils/SiteHeading"
import SiteParagraph from "../../../../utils/SiteParagraph"
import SiteContainer from "../../../../utils/SiteContainer"

const PunchLine = () => <>A web-based, data-driven prediction tool</>
const Heading = () => <>Personal GDM for lifestyle intervention</>
const Content = () => (
  <>
    This evidence-based tool is designed to be used by pregnant women and their health-care providers.
    This tool is a guide only for the identification of potentially eligible women to be recruited into
    clinical trials for having a higher risk of GDM. The entered information categorises women into one
    of two groups: higher risk of GDM, and low risk of GDM.
  </>
)

const HeroSectionViewOnDesktop: React.FC<{ ButtonComponent?: any }> = ({
  ButtonComponent,
}) => {
  let _button = null
  if (ButtonComponent) _button = ButtonComponent
  return (
    <div className="px-6 py-12 sm:pl-12 sm:pr-12 xl:pl-16 bg-site-blue text-white  border-b h-full">
      <SiteParagraph className="text-xl sm:text-xl" colorClassName="text-white">
        <PunchLine />
      </SiteParagraph>
      <SiteHeading colorClassName="text-white">
        <Heading />
      </SiteHeading>
      <SiteParagraph className="my-5" colorClassName="text-white">
        <Content />
      </SiteParagraph>
      <div className="mt-8 mb-2 flex">{_button}</div>
    </div>
  )
}

const HeroSectionViewOnMobile: React.FC<{ ButtonComponent?: any }> = ({
  ButtonComponent,
}) => {
  let _button = null
  if (ButtonComponent) _button = ButtonComponent
  return (
    <div className="bg-white py-8 border-b bg-site-blue">
      <SiteContainer className="text-center">
        <div className="px-2">
          <SiteParagraph
            className="text-xl sm:text-xl"
            colorClassName="text-white"
          >
            <PunchLine />
          </SiteParagraph>
          <SiteHeading colorClassName="text-white">
            <Heading />
          </SiteHeading>
          <SiteParagraph className="my-5" colorClassName="text-white">
            <Content />
          </SiteParagraph>
          <div className="mt-6 flex justify-center">{_button}</div>
        </div>
      </SiteContainer>
    </div>
  )
}

const HeroSectionView: React.FC<{ ButtonComponent?: any }> = ({
  ButtonComponent,
}) => {
  return (
    <>
      <section className="hidden lg:block">
        <HeroSectionViewOnDesktop ButtonComponent={ButtonComponent} />
      </section>
      <section className="block lg:hidden">
        <HeroSectionViewOnMobile ButtonComponent={ButtonComponent} />
      </section>
    </>
  )
}

const HeroSection: React.FC<{ Button?: any }> = ({ Button }) => {
  return <HeroSectionView ButtonComponent={Button} />
}

export default HeroSection
